import React from 'react';

const BlancSignaturContent = ({ product, sectionsRef }) => {
  return (
    <>
      {/* Hero Section */}
      <div
        ref={(el) => (sectionsRef.current[0] = el)}
        className="text-center mb-24"
      >
        <p className="text-sm tracking-[0.3em] uppercase mb-6" style={{ color: 'var(--atelier-gold)' }}>
          SIGNATURE
        </p>
        <h1 className="text-6xl md:text-8xl font-light mb-8" style={{ color: 'var(--atelier-black)' }}>
          Uno Signatur Blanc
        </h1>
        <p className="text-xl md:text-2xl font-light italic max-w-3xl mx-auto" style={{ color: 'var(--atelier-grey)' }}>
          Zijdezacht. Verfijnd. Verleidelijk.
        </p>
      </div>

      {/* Product Image */}
      <div
        ref={(el) => (sectionsRef.current[1] = el)}
        className="max-w-2xl mx-auto mb-24"
      >
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-auto"
        />
      </div>

      {/* Het Verhaal */}
      <section
        ref={(el) => (sectionsRef.current[2] = el)}
        className="max-w-4xl mx-auto mb-24"
      >
        <div className="w-24 h-px bg-[var(--atelier-gold)] mb-8" />
        <h2 className="text-4xl md:text-5xl font-light mb-8" style={{ color: 'var(--atelier-black)' }}>
          Het Verhaal
        </h2>
        <div className="space-y-6 text-lg leading-relaxed" style={{ color: 'var(--atelier-grey)' }}>
          <p>
            Er is een kant van Duo Penotti die altijd al in de schaduw stond.
          </p>
          <p>
            Het witte gedeelte. De stille helft. Degene die de chocolade liet schitteren maar zelf nooit het podium kreeg.
          </p>
          <p className="text-xl font-light" style={{ color: 'var(--atelier-black)' }}>
            Tot nu.
          </p>
          <p>
            Uno Signatur Blanc is ons eerbetoon aan de elegantie van terughoudendheid. Geen intense cacao die om aandacht schreeuwt. 
            Geen hazelnoot die domineert. Alleen de fluweelzachte omhelzing van witte chocolade, de bloemige complexiteit van echte vanille, 
            en een vleugje karamel die alles samenbrengt.
          </p>
          <p className="text-xl font-light italic" style={{ color: 'var(--atelier-gold)' }}>
            Dit is verfijning in haar puurste vorm.
          </p>
        </div>
      </section>

      {/* De Oorsprong */}
      <section
        ref={(el) => (sectionsRef.current[3] = el)}
        className="max-w-4xl mx-auto mb-24"
      >
        <div className="w-24 h-px bg-[var(--atelier-gold)] mb-8" />
        <h2 className="text-4xl md:text-5xl font-light mb-12" style={{ color: 'var(--atelier-black)' }}>
          De Oorsprong
        </h2>

        <div>
          <h3 className="text-2xl font-light mb-4" style={{ color: 'var(--atelier-black)' }}>
            België — Het Hart van Chocolade
          </h3>
          <div className="space-y-4 text-lg leading-relaxed" style={{ color: 'var(--atelier-grey)' }}>
            <p>
              Witte chocolade is geen chocolade, zeggen de puristen.
            </p>
            <p>
              Wij zeggen: ze hebben de verkeerde witte chocolade geproefd.
            </p>
            <p>
              Onze Belgische witte chocolade komt van een familieproducent in Antwerpen die al vier generaties de kunst beheerst. 
              Geen goedkope cacaoboter-vervangers. Geen overdaad aan suiker om slechte kwaliteit te maskeren.
            </p>
            <p className="text-2xl font-light" style={{ color: 'var(--atelier-gold)' }}>
              33% echte cacaoboter. De rest is vakmanschap.
            </p>
            <p>
              De cacaoboter wordt zorgvuldig gedesodoriseerd — net genoeg om ruwheid weg te nemen, maar niet zoveel dat de subtiele 
              cacaotonen verdwijnen. Het resultaat is roomwit, niet krijtwit. Rijk, niet vettig.
            </p>
          </div>
        </div>
      </section>

      {/* De Ingrediënten */}
      <section
        ref={(el) => (sectionsRef.current[4] = el)}
        className="max-w-4xl mx-auto mb-24"
      >
        <div className="w-24 h-px bg-[var(--atelier-gold)] mb-8" />
        <h2 className="text-4xl md:text-5xl font-light mb-12" style={{ color: 'var(--atelier-black)' }}>
          De Ingrediënten
        </h2>

        <div className="space-y-12">
          {/* Belgische Witte Chocolade */}
          <div>
            <h3 className="text-2xl font-light mb-4" style={{ color: 'var(--atelier-black)' }}>
              Belgische Witte Chocolade
            </h3>
            <div className="space-y-4 text-lg leading-relaxed" style={{ color: 'var(--atelier-grey)' }}>
              <p>
                Het fundament. Onze chocolatier in Antwerpen produceert exclusief voor Penotti Atelier. Kleine batches, 
                strenge kwaliteitscontrole, en een recept dat in 87 jaar niet is veranderd.
              </p>
              <p>
                De cacaoboter komt van dezelfde bonen die gebruikt worden voor de beste pure chocolade — een kwaliteitsniveau 
                dat de meeste witte chocolade nooit bereikt.
              </p>
            </div>
          </div>

          {/* Tahitiaanse Vanille */}
          <div>
            <h3 className="text-2xl font-light mb-4" style={{ color: 'var(--atelier-black)' }}>
              Tahitiaanse Vanille
            </h3>
            <div className="space-y-4 text-lg leading-relaxed" style={{ color: 'var(--atelier-grey)' }}>
              <p>
                Niet Madagascar. Niet Bourbon. Tahiti.
              </p>
              <p>
                Tahitiaanse vanille is zeldzamer, bloemiger, en complexer dan haar bekendere zusjes. Waar Bourbon-vanille 
                warm en vertrouwd smaakt, is Tahitiaanse vanille verfijnd en verrassend — met tonen van kers, anijs en een vleugje pruim.
              </p>
              <p>
                De stokjes groeien op kleine plantages in Frans-Polynesië, waar het klimaat en de vulkanische grond een vanille 
                produceren die parfumeurs en patissiers wereldwijd najagen.
              </p>
              <p className="text-xl font-light" style={{ color: 'var(--atelier-gold)' }}>
                Wij gebruiken het merg van de stokjes. Geen extract. Geen aroma.
              </p>
            </div>
          </div>

          {/* Nederlandse Room & Fleur de Sel */}
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <h3 className="text-2xl font-light mb-4" style={{ color: 'var(--atelier-black)' }}>
                Nederlandse Room
              </h3>
              <p className="text-lg leading-relaxed" style={{ color: 'var(--atelier-grey)' }}>
                Vers van lokale boerderijen rondom Roosendaal. De room voegt body toe zonder te verzwaren, 
                en creëert de signature zijdezachte textuur die Blanc onderscheidt.
              </p>
            </div>
            <div>
              <h3 className="text-2xl font-light mb-4" style={{ color: 'var(--atelier-black)' }}>
                Fleur de Sel
              </h3>
              <div className="space-y-4 text-lg leading-relaxed" style={{ color: 'var(--atelier-grey)' }}>
                <p>
                  Een snufje zeezout uit de kustgebieden van Bretagne. Onzichtbaar in de smaak, maar essentieel in het effect. 
                  Het zout tilt de zoetheid naar een hoger niveau en voorkomt dat de rijkheid overweldigend wordt.
                </p>
                <p className="text-lg font-light italic" style={{ color: 'var(--atelier-black)' }}>
                  Het geheim dat patissiers al eeuwen kennen: zout maakt zoet compleet.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Het Proces */}
      <section
        ref={(el) => (sectionsRef.current[5] = el)}
        className="max-w-4xl mx-auto mb-24"
      >
        <div className="w-24 h-px bg-[var(--atelier-gold)] mb-8" />
        <h2 className="text-4xl md:text-5xl font-light mb-12" style={{ color: 'var(--atelier-black)' }}>
          Het Proces
        </h2>

        <div className="space-y-12">
          {/* Tempereren */}
          <div>
            <h3 className="text-2xl font-light mb-4" style={{ color: 'var(--atelier-black)' }}>
              Tempereren
            </h3>
            <div className="space-y-4 text-lg leading-relaxed" style={{ color: 'var(--atelier-grey)' }}>
              <p>
                Witte chocolade is onvergevend.
              </p>
              <p>
                Te warm en de cacaoboter scheidt. Te koud en de textuur wordt korrelig. Het tempereerproces — het gecontroleerd 
                opwarmen en afkoelen — vereist precisie tot op de graad.
              </p>
              <div className="bg-white/50 p-6 rounded">
                <p className="text-2xl font-light" style={{ color: 'var(--atelier-gold)' }}>
                  28°C. Niet meer. Niet minder.
                </p>
              </div>
              <p>
                Onze maîtres chocolatiers controleren elke batch met de hand. Machines kunnen veel, maar het herkennen van de 
                perfecte glans en viscositeit blijft mensenwerk.
              </p>
            </div>
          </div>

          {/* Infusie */}
          <div>
            <h3 className="text-2xl font-light mb-4" style={{ color: 'var(--atelier-black)' }}>
              Infusie
            </h3>
            <div className="space-y-4 text-lg leading-relaxed" style={{ color: 'var(--atelier-grey)' }}>
              <p>
                De Tahitiaanse vanille wordt niet simpelweg toegevoegd. Ze wordt geïnfuseerd.
              </p>
              <p>
                De room wordt zachtjes verwarmd met de vanillestokjes — urenlang, tot de smaken volledig zijn samengesmolten. 
                Daarna wordt de room gezeefd, maar de vanillezaadjes blijven. Je ziet ze als kleine zwarte puntjes in de crème.
              </p>
              <p className="text-2xl font-light" style={{ color: 'var(--atelier-gold)' }}>
                12 uur infusietijd. Voor elke batch.
              </p>
            </div>
          </div>

          {/* Karamelisatie */}
          <div>
            <h3 className="text-2xl font-light mb-4" style={{ color: 'var(--atelier-black)' }}>
              Karamelisatie
            </h3>
            <div className="space-y-4 text-lg leading-relaxed" style={{ color: 'var(--atelier-grey)' }}>
              <p>
                De subtiele karameltonen komen niet van toegevoegde karamel. Ze ontstaan natuurlijk, door de lichte verhitting 
                van de melksuikers in de room. Een proces dat de Fransen "Maillard-reactie" noemen.
              </p>
              <p className="text-xl font-light italic" style={{ color: 'var(--atelier-black)' }}>
                Gecontroleerde bruining. Diepte zonder donkerte.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Proefnotities */}
      <section
        ref={(el) => (sectionsRef.current[6] = el)}
        className="max-w-4xl mx-auto mb-24 bg-white/50 p-12 rounded"
      >
        <div className="w-24 h-px bg-[var(--atelier-gold)] mb-8" />
        <h2 className="text-4xl md:text-5xl font-light mb-12" style={{ color: 'var(--atelier-black)' }}>
          Proefnotities
        </h2>

        <div className="space-y-6">
          <div>
            <h4 className="text-lg font-medium mb-2" style={{ color: 'var(--atelier-gold)' }}>
              Aroma
            </h4>
            <p className="text-lg" style={{ color: 'var(--atelier-grey)' }}>
              Bij het openen — direct de warme, ronde geur van cacaoboter en vanille. Geen scherpe zoetheid, maar uitnodigende zachtheid.
            </p>
          </div>
          <div>
            <h4 className="text-lg font-medium mb-2" style={{ color: 'var(--atelier-gold)' }}>
              Eerste hap
            </h4>
            <p className="text-lg" style={{ color: 'var(--atelier-grey)' }}>
              De witte chocolade smelt onmiddellijk. Romig, vol, maar verrassend licht.
            </p>
          </div>
          <div>
            <h4 className="text-lg font-medium mb-2" style={{ color: 'var(--atelier-gold)' }}>
              Ontwikkeling
            </h4>
            <p className="text-lg" style={{ color: 'var(--atelier-grey)' }}>
              De vanille ontvouwt zich in lagen. Eerst bloemig, dan fruitig, met een subtiele kruidigheid die je niet verwacht.
            </p>
          </div>
          <div>
            <h4 className="text-lg font-medium mb-2" style={{ color: 'var(--atelier-gold)' }}>
              Karameltoets
            </h4>
            <p className="text-lg" style={{ color: 'var(--atelier-grey)' }}>
              Halverwege verschijnt de karamel — geen schreeuwende zoetheid, maar een warme gloed die de andere smaken verbindt.
            </p>
          </div>
          <div>
            <h4 className="text-lg font-medium mb-2" style={{ color: 'var(--atelier-gold)' }}>
              Afdronk
            </h4>
            <p className="text-lg" style={{ color: 'var(--atelier-grey)' }}>
              Lang en elegant. De room blijft hangen, de vanille echo't na.
            </p>
          </div>
          <div>
            <h4 className="text-lg font-medium mb-2" style={{ color: 'var(--atelier-gold)' }}>
              Textuur
            </h4>
            <p className="text-lg" style={{ color: 'var(--atelier-grey)' }}>
              Zijdezacht. Lichter dan de hazelnootvarianten. Smelt bij aanraking.
            </p>
          </div>
        </div>
      </section>

      {/* Momenten */}
      <section
        ref={(el) => (sectionsRef.current[7] = el)}
        className="max-w-4xl mx-auto mb-24"
      >
        <div className="w-24 h-px bg-[var(--atelier-gold)] mb-8" />
        <h2 className="text-4xl md:text-5xl font-light mb-12" style={{ color: 'var(--atelier-black)' }}>
          Momenten
        </h2>

        <div className="space-y-8">
          <p className="text-xl leading-relaxed" style={{ color: 'var(--atelier-grey)' }}>
            Uno Signatur Blanc is niet voor elk moment.
          </p>
          <p className="text-xl leading-relaxed" style={{ color: 'var(--atelier-grey)' }}>
            Dit is voor stilte. Voor ochtenden die nog niet begonnen zijn. Voor momenten waarop je jezelf even op de eerste plaats zet.
          </p>

          <div>
            <h3 className="text-2xl font-light mb-4" style={{ color: 'var(--atelier-black)' }}>
              Het Perfecte Moment
            </h3>
            <div className="space-y-4 text-lg leading-relaxed" style={{ color: 'var(--atelier-grey)' }}>
              <p>
                Een verse croissant. Licht geroosterd. De Blanc op kamertemperatuur, zodat ze vloeibaar genoeg is om in de laagjes te trekken. 
                Een kop earl grey ernaast — de bergamot complementeert de vanille.
              </p>
              <p className="text-xl font-light italic" style={{ color: 'var(--atelier-gold)' }}>
                Geen haast. Geen afleiding.
              </p>
            </div>
          </div>

          <div>
            <h3 className="text-2xl font-light mb-4" style={{ color: 'var(--atelier-black)' }}>
              Verrassende Combinaties
            </h3>
            <ul className="space-y-2 text-lg" style={{ color: 'var(--atelier-grey)' }}>
              <li>• Op warm bananenbrood, net uit de oven</li>
              <li>• Gesmolten als dip voor verse aardbeien</li>
              <li>• Door warme melk als ultieme witte chocolademelk</li>
              <li>• Als topping op Greek yoghurt met granola</li>
              <li>• Op een gezouten cracker — het contrast is hemels</li>
            </ul>
          </div>
        </div>
      </section>

      {/* De Filosofie van Wit */}
      <section
        ref={(el) => (sectionsRef.current[8] = el)}
        className="max-w-4xl mx-auto mb-24"
      >
        <div className="w-24 h-px bg-[var(--atelier-gold)] mb-8" />
        <h2 className="text-4xl md:text-5xl font-light mb-8" style={{ color: 'var(--atelier-black)' }}>
          De Filosofie van Wit
        </h2>
        <div className="space-y-6 text-lg leading-relaxed" style={{ color: 'var(--atelier-grey)' }}>
          <p>
            In een wereld die schreeuwt om aandacht, is Blanc een fluistering.
          </p>
          <p>
            Waar Uno Signatur (de bruine) intens en onvergetelijk is, is Blanc subtiel en verleidelijk. Ze overheerst niet. 
            Ze omarmt. Ze is niet het hoofdgerecht, maar de finishing touch die alles verheft.
          </p>
          <p className="text-xl font-light italic" style={{ color: 'var(--atelier-black)' }}>
            Sommigen zullen haar te zacht vinden. Te bescheiden. Die mensen begrijpen niet dat de hoogste kunst soms de minste moeite lijkt.
          </p>
        </div>
      </section>

      {/* Specificaties */}
      <section
        ref={(el) => (sectionsRef.current[9] = el)}
        className="max-w-4xl mx-auto mb-24"
      >
        <div className="w-24 h-px bg-[var(--atelier-gold)] mb-8" />
        <h2 className="text-4xl md:text-5xl font-light mb-12" style={{ color: 'var(--atelier-black)' }}>
          Specificaties
        </h2>

        <div className="bg-white/50 p-8 rounded">
          <table className="w-full">
            <tbody className="space-y-4">
              {[
                ['Inhoud', '300g'],
                ['Chocolade', 'Belgische witte, 33% cacaoboter'],
                ['Vanille', 'Tahitiaans, hele stokjes'],
                ['Room', 'Nederlandse, lokaal gesourced'],
                ['Zout', 'Fleur de Sel, Bretagne'],
                ['Infusietijd', '12 uur'],
                ['Productie', 'Roosendaal, Nederland'],
                ['Bewaaradvies', 'Op kamertemperatuur, na openen binnen 6 weken'],
              ].map(([key, value]) => (
                <tr key={key} className="border-b border-gray-200">
                  <td className="py-4 text-lg font-light" style={{ color: 'var(--atelier-black)' }}>
                    {key}
                  </td>
                  <td className="py-4 text-lg text-right" style={{ color: 'var(--atelier-grey)' }}>
                    {value}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      {/* Het Geheim */}
      <section
        ref={(el) => (sectionsRef.current[10] = el)}
        className="max-w-4xl mx-auto mb-24 text-center"
      >
        <div className="w-24 h-px bg-[var(--atelier-gold)] mx-auto mb-12" />
        <div className="space-y-6 text-lg leading-relaxed" style={{ color: 'var(--atelier-grey)' }}>
          <p>
            Vraag aan iemand wat hun favoriete deel van Duo Penotti was.
          </p>
          <p>
            De helft zegt bruin. De andere helft — vaak met een glimlach, alsof ze iets bekennen — zegt wit.
          </p>
          <p className="text-2xl font-light mt-8" style={{ color: 'var(--atelier-black)' }}>
            Uno Signatur Blanc is voor hen.
          </p>
          <p className="text-xl">
            Voor de stille liefhebbers. Voor wie weet dat elegantie geen volume nodig heeft.
          </p>
        </div>

        <div className="mt-16">
          <p className="text-xl font-light italic mb-6" style={{ color: 'var(--atelier-grey)' }}>
            "De mooiste dingen fluisteren. Je moet alleen leren luisteren."
          </p>
          <p className="text-2xl font-light" style={{ color: 'var(--atelier-black)' }}>
            Uno Signatur Blanc. Stille Elegantie.
          </p>
        </div>
      </section>
    </>
  );
};

export default BlancSignaturContent;
